
import axios from '../../utils/AxiosWrapper'
import { pluralize } from '../../utils/helpers'
import axiosMethodRequest from '../../config/service'
import apiCalls from '../../config/apiCalls'
import { GetSessionValue } from '../../utils/sessionStorage'


const setEntityData = (type, data) => {
  return {
    type: `SET_SELECT_ENTITIES_${pluralize(type).toUpperCase()}_DATA`,
    payload: data
  }
}

const setProjections = data => {

  return {
    type: `SET_PROJECTIONS_DATA`,
    payload: data
  }
}
const setBrandData = data => {

  return {
    type: `SET_SELECT_ENTITIES_BRANDS_DATA`,
    payload: data
  }
}
const setCampaignTemplates = data => {

  return {
    type: `SET_CAMPAIGN_TEMPLATE_DATA`,
    payload: data
  }
}
const setPreviewData = data => {
  return {
    type: `SET_PREVIEW_DATA`,
    payload: data
  }
}
const setCsvData = data => {
  return {
    type: `SET_CSV_DATA`,
    payload: data
  }
}
const setInitialData = data => {
  return {
    type: `SET_INITIAL_DATA`,
    payload: data
  }
}
const setCampaignResponseData = data => {
  return {
    type: `SET_CAMPAIGN_RESPONSE_DATA`,
    payload: data
  }
}

const setTabData = data => {
  return {
    type: `SET_TAB_DATA`,
    payload: data
  }
}

export const getEntityForSelectAction = (type, callback) => {
  return dispatch => {
    // setEntityLoadingState(type, true)
    let userDetails = GetSessionValue('loginCredentials')
    return axiosMethodRequest('GET', `${apiCalls.users}`).then((res) => {
      if (res && res.data && res.data.respCode) {
        let data = res.data.users
        callback(data)
        dispatch(setEntityData(type, data))
      }
    })


    // return axios
    //   .get(`/${pluralize(type.toLowerCase())}/list`, { params })
    //   .then(res => {
    // let data = res.data
    // dispatch(setEntityData(type, data))
    //   })
    //   .catch(err => {
    //     console.log(err)
    //   })
  }
}


export const getProjectionsForUserAction = (id, callback) => {
  return dispatch => {
    // setEntityLoadingState(type, true)
    // return axiosMethodRequest('GET',)
    return axiosMethodRequest('GET', `brands/${id}`).then((res) => {
      if (res && res.data && res.data.respCode) {
        let data = res.data.details.json
        let details = res.data.details
        if (callback) {
          callback(data)
        }
        dispatch(setProjections(data))
        dispatch(setBrandData(details))
      }
    })
  }
}
export const getProjectionsForUserActionTrain = (id, callback) => {
  return dispatch => {
    // setEntityLoadingState(type, true)
    // return axiosMethodRequest('GET',)
    return axiosMethodRequest('GET', `brands/${id}`).then((res) => {
      if (res && res.data && res.data.respCode) {
        let data = res.data.details.json;
        let details = res.data.details;
        dispatch(setProjections(data))
        dispatch(setBrandData(details))
        if (callback) {
          callback(details)
        }
      }
    })
  }
}
export const loadBrandData = (details) => {
  console.log('pppppp')
  return dispatch => {
    dispatch(setBrandData(details))
  }
}
export const getCampaignTemplateData = (type, callback) => {
  return dispatch => {
    let url = ''
    let filterCriteria = {};
    filterCriteria['criteria'] = [{ key: 'type', value: type, type: 'eq' }];
    filterCriteria['direction'] = 'desc';
    filterCriteria.sortfield = 'created';
    url = `campaignTemplates?filter=${JSON.stringify(filterCriteria)}`;
    return axiosMethodRequest('GET', url).then((res) => {
      if (res && res.data && res.data.respCode) {
        let data = res.data.campaignTemplates
        if (callback) {
          callback(data)
        }


        dispatch(setCampaignTemplates(data))
      }
    })
  }
}
export const setPreviewDataAction = (data) => {
  return dispatch => {
    return dispatch(setPreviewData(data))
  }
}
export const saveCsvAction = (data) => {
  return dispatch => {
    return dispatch(setCsvData(data))
  }
}
export const saveinitialValuesAction = (data) => {
  return dispatch => {
    return dispatch(setInitialData(data))
  }
}
export const savecampaignResponseAction = (data) => {
  return dispatch => {
    return dispatch(setCampaignResponseData(data))
  }
}
export const saveTabData = (data) => {
  return dispatch => {
    return dispatch(setTabData(data))
  }
}
export const clearCampaignTemplateData = () => {
  return dispatch => {
    return dispatch(setCampaignTemplates(null))
  }
}